// Are we using this? If not delete this
export const currencyMethodsMixin = {
  methods: {
    formatCurrency(amount, curency) {
      if (typeof amount === 'string' || amount instanceof String) {
        amount = parseInt(amount, 10);
      }
      if (this.toLocaleStringSupportsOptions) {
        const options = {
          style: 'currency',
          currency: curency.key,
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        };
        return amount.toLocaleString(undefined, options);
      }
      amount = Math.round(amount);
      return curency.symbol + amount;
    },
    /* eslint-disable operator-linebreak */
    toLocaleStringSupportsOptions() {
      return !!(
        typeof Intl !== 'undefined' &&
        Intl &&
        typeof Intl.NumberFormat !== 'undefined'
      );
    },
  },
};
